import type { ComponentProps } from "react"

/** Lucide square-stop: a frame with an inner window (the canvas focus tool) */
export default function CanvasFocus(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const {
    fill: _ignoredFill,
    stroke = "currentColor",
    strokeWidth = 2,
    strokeLinecap = "round",
    strokeLinejoin = "round",
    ...svgProps
  } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      aria-hidden
      {...svgProps}
    >
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <rect x="9" y="9" width="6" height="6" rx="1" />
    </svg>
  )
}
